<template>
    <div v-if="bannerVisible" class="vehicle-search-banner">
        <div class="vehicle-search-banner__content">
            <a class="vehicle-search-banner__close" @click="closeBanner">
                <svg-icon name="close" />
            </a>
            <img
                class="vehicle-search-banner__desktop-img"
                src="~/assets/images/request.svg"
                width="55"
                height="89"
                alt="rentable outside of switzerland image"
            />
            <div>
                <p class="vehicle-search-banner__title">
                    {{ $t('pages.vehicles.rentable_outside_switzerland') }}
                </p>
                <div class="vehicle-search-banner__description">
                    <span>
                        {{ $t('pages.vehicles.rentable_outside_switzerland_desc') }}
                    </span>
                    <img
                        class="vehicle-search-banner__mobile-img"
                        src="~/assets/images/request.svg"
                        width="55"
                        height="89"
                        alt="rentable outside of switzerland image"
                    />
                </div>

                <div class="vehicle-search-banner__toggle">
                    <p>{{ $t('pages.vehicles.rentable_outside_switzerland_toggle_info') }}</p>
                    <Toggle v-model="selected" size="medium" on-value="true" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Toggle from '~/components/form-elements/Toggle';
import { BALOISE_INSURANCE_LIMITS } from '~/config/insurance';
import { buildQuery, getFilterValue } from '~/helpers/queryParser';
import { COUNTRY, RENTABLE_OUTSIDE_OF_SWITZERLAND } from '~/config/filterKeys';

export default {
    name: 'RentableOutsideSwitzerlandFilter',
    components: { Toggle },
    data() {
        return {
            bannerVisible: false,
            isBannerClosed: false,
        };
    },
    computed: {
        ...mapGetters(['standByFilters', 'isLoggedIn', 'isRenter', 'user']),
        selected: {
            get() {
                const standByFilter = this.standByFilters[RENTABLE_OUTSIDE_OF_SWITZERLAND];

                if (standByFilter !== undefined) {
                    return standByFilter;
                }

                return getFilterValue(this.$route.query, RENTABLE_OUTSIDE_OF_SWITZERLAND);
            },
            set(value) {
                const query = buildQuery(this.$route.query, { [RENTABLE_OUTSIDE_OF_SWITZERLAND]: value });
                this.$router.push({ query });
            },
        },
        locationFilterValue() {
            return getFilterValue(this.$route.query, COUNTRY);
        },
    },
    watch: {
        locationFilterValue() {
            this.bannerVisible = this.checkIsBannerVisible();
        },
        isLoggedIn() {
            this.bannerVisible = this.checkIsBannerVisible();
        },
    },
    mounted() {
        this.isBannerClosed = sessionStorage.getItem('rentableOutsideSwitzerlandBannerClosed') === 'true';

        if (this.locationFilterValue) {
            this.bannerVisible = this.checkIsBannerVisible();
        }
    },
    methods: {
        closeBanner() {
            this.bannerVisible = false;
            this.isBannerClosed = true;
            sessionStorage.setItem('rentableOutsideSwitzerlandBannerClosed', 'true');
        },
        checkIsBannerVisible() {
            if (this.isLoggedIn && this.user?.country) {
                return;
            }

            const country = this.$meService.getUserCountryBasedOnTimezone();
            const userIsOutsideOfSwitzerland = !BALOISE_INSURANCE_LIMITS.allowedRenterCountryCodes.includes(
                country?.code || null
            );
            const filteredForSwissVehicles = BALOISE_INSURANCE_LIMITS.allowedRenterCountryCodes.includes(
                this.locationFilterValue
            );

            return userIsOutsideOfSwitzerland && filteredForSwissVehicles && !this.isBannerClosed;
        },
    },
};
</script>
